import React, { useMemo, useEffect } from 'react';
import { useOrientation } from '../../../Hooks/useOrientation';
import './VerticalNavbar.css'; // We'll create this CSS file
import { urlApiServerImage } from '../../../Config/Config';
// import { urlApiServerImage } from '../../../Config/Config';

const processItemsWithLogos = (items) =>
  items.map((item) => {
    const path = item.Logo[0].url;
    // Extrae solo el nombre del archivo y lo construye manualmente
    // const fileName = path.split('/').pop(); // PadreSegundoLogo1.png
    return {
      ...item,
      logoUrl: `${urlApiServerImage}${path}`,
    };
  });


const VerticalNavbar = ({ items, onItemClick, activeItem }) => {
  const processedItems = useMemo(() => processItemsWithLogos(items), [items]);
  const orientation = useOrientation();
  const isPortrait = orientation === 'portrait';
const defaultIndex = 0; // ← cámbialo dinámicamente si quieres otra posición

useEffect(() => {
  if (
    processedItems.length > defaultIndex && // verifica que exista esa posición
    (activeItem === null || activeItem !== defaultIndex)
  ) {
    onItemClick(defaultIndex); // ← mandas el índice
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [processedItems]);

  return (
    <div className={`vertical-navbar-container ${isPortrait ? 'portrait-mode' : 'landscape-mode'}`}>
      {/* Fixed header */}
      <div className="navbar-header">
        Lineas
      </div>

      {/* Scrollable container */}
      <div className={`items-container ${isPortrait ? 'portrait-layout' : 'landscape-layout'}`}>
        {processedItems.map((item, index) => {
          const isActive = activeItem === index;
          const baseStyle = {
            backgroundImage: `url(${item.logoUrl})`,
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          };
          const style = isActive
            ? { ...baseStyle, backgroundColor: item?.color_principals?.[0]?.codigo_hexadecimal }
            : baseStyle;

          return (
            <div key={item.id} className="nav-item">
              <label className={`item-label ${isActive ? 'active-label' : 'inactive-label'}`}>
                {item.Nombre}
              </label>
              <button
                onClick={() => onItemClick(index)}
                className={`item-button ${isActive ? 'active-button' : 'inactive-button'}`}
                style={style}
                aria-current={isActive ? "true" : "false"}
              />
              {/* Spacing between items */}
              <div className="item-spacing"></div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default VerticalNavbar;